import React, { useState } from 'react';
import Image from 'next/image';
import { isItUndefined } from '../../util/DataUtil';
import { Each } from '../../util/Each';
import { Constants } from '../../util/Constants';

const AuthorBlock = ({ data, width }) => {
  return (
    <div id={'author-block'}>
      {/* <span className={'block-title'}>
        {isItUndefined(data?.field_block_title)}
      </span> */}
      <div className={'block-wrapper'}>
        <div className={'author-photo'}>
          {data?.field_author_photo?.length !== 0 ? (
            <Image
              priority
              alt="author-photo"
              src={data?.field_author_photo?.webimage}
              width={104}
              height={104}
              className={'image'}
            />
          ) : (
            <img src={'/images/dlr.png'} />
          )}
        </div>
        <div className={'text-wrapper'}>
          <div className={'name'}>{isItUndefined(data?.field_author_name)}</div>
          <div
            className="author-title"
            dangerouslySetInnerHTML={{
              __html: isItUndefined(data?.field_author_title_and_company),
            }}
          />
          <div className={'author-bio'}>
            {isItUndefined(data?.field_author_bio)}
          </div>
          <div className={'view-more-wrapper'}>
            {isItUndefined(data?.field_view_more_url) && (
              <>
                <a href={isItUndefined(data?.field_view_more_url)}>
                  {isItUndefined(data?.field_view_more_label)}
                </a>
                <img
                  alt="more-arrow-icon"
                  className={'arrow'}
                  src={'/images/learn-more-arrow.svg'}
                />
              </>
            )}
          </div>
          <div className={'social-icons-wrapper'}>
            <Each
              of={data?.field_social_icons?.social_icons_paragraph}
              render={(item, index) =>
                item?.field_social_icon?.webimage && (
                  <div className={'social'} key={index}>
                    <a href={isItUndefined(item?.field_social_link)}>
                      <img
                        className={'social-icon'}
                        src={
                          Constants.cloudinaryImage +
                          item?.field_social_icon?.webimage
                        }
                        alt="social-image"
                      />
                    </a>
                  </div>
                )
              }
            />
          </div>
          {/*<div*/}
          {/*  className="author-bio"*/}
          {/*  dangerouslySetInnerHTML={{*/}
          {/*    __html: isItUndefined(data?.field_author_bio),*/}
          {/*  }}*/}
          {/*/>*/}
        </div>
      </div>
    </div>
  );
};

export default AuthorBlock;
